<template>
	<div id="cashieraccount" class="public-content">
    <!-- 公共form表单样式 -->
    <div class="form-item-public">
      <el-form inline label-position="left" :model="formData">
        <el-form-item label="核对总账">
          <el-select placeholder="请选择" size="small" v-model="formData.yearPeriods" @change="getData()">
            <el-option v-for="(item,index) in dictList.option" :key="index" :label="item.year+'年'+item.periods+'期'" :value="item.yearPeriods"></el-option>
          </el-select>
        </el-form-item>
    		<el-form-item class="fr">
          <el-checkbox  v-model="formData.isShow" @change="getData()">显示禁用账户</el-checkbox>
          <div v-for="item in buttonList" style='display: inline-block;padding-left:10px;'>
              <el-dropdown size="small">
                  <el-button size="small" >
                    {{item.name}} <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" v-if='item.function == "print"'>
                      <el-dropdown-item @click.native="handlePrint('transverse')">横向A4</el-dropdown-item>
                      <el-dropdown-item @click.native="handlePrint('')">纵向A4</el-dropdown-item>
                  </el-dropdown-menu>
                  <el-dropdown-menu slot="dropdown" v-if='item.function == "export"'>
                      <el-dropdown-item @click.native="handleExport('Excel')">Excel</el-dropdown-item>
                      <el-dropdown-item @click.native="handleExport('PDF')">PDF</el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
          </div>
    		</el-form-item>
      </el-form>
    </div>
    <!-- 公共table 样式 -->
    <div class="table-item-public">
      <el-table border style="width:100%" :data="tableData"
        row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        v-loading="loadings" element-loading-text="查询列表数据中"  :span-method="arraySpanMethod" :row-style='rowStyleColor'
       header-cell-class-name='headerStyleColors'
      >
        <el-table-column label="类型" prop="type" width="220">
          <template slot-scope="scope">
            <span :class="(scope.row.myType && scope.row.myType == '1') ? 'red' : ''">{{scope.row.type}}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目" align="center">
          <template slot-scope="scope">
              <span v-if="scope.row.subjectName">{{scope.row.subjectCode+' '+scope.row.subjectName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="期初" align="center" prop="initialBalance"></el-table-column>
        <el-table-column label="借方发生（收入）" align="center" prop="monCountDebitMoney"></el-table-column>
        <el-table-column label="贷方发生（支出）" align="center" prop="monCreditorMoney"></el-table-column>
        <el-table-column label="期末余额" align="center" prop="monRemainingSum"></el-table-column>
      </el-table>
    </div>
    <!-- 公共 page 样式 -->
    <!-- <div class="page-item-public">
    	<el-pagination background small
    	@size-change="pageSizeChange"  @current-change="pageIndexChange" @prev-click="pageIndexChange" @next-click="pageIndexChange"
    	layout="total, prev, pager, next, sizes, jumper" :total="page.totall" :current-page="page.pageIndex" :page-size="page.pageSize">
    	</el-pagination>
    </div> -->
	</div>
</template>

<script>
  import {currencys} from '@/assets/utils/currencyFormat'

  export default{
    data(){
      return {
        isFirstActive: false,
        buttonList:[], // 按钮集合
        page:{
          pageIndex:1,
          pageSize:10,
          totall:0,
        },
        loadings:false,
        tableData:[],
        formData:{
          yearPeriods:''
        },

        dictList:{
          option:[]
        }
      }
    },
    created(){
      this.getButtonAuthorize();
       this.getAccountPeriod()
    },
    mounted(){

    },
    methods:{
      // 合并行
      arraySpanMethod({row, column , rowIndex , columnIndex}) {
         if(row.children) {
            return [1, 6];
         }
      },
      // 表格行样式显示
      rowStyleColor({row, column , rowIndex , columnIndex}) {
         if(row.children) {
           return 'text-align: left';
         }else if(row.myType == "1") {
            return 'background:#F7F7F7';
         }else if(row.type == "会计科目") {
            return 'background:#F7F7F7';
         }else {
             return 'text-align: center';
         }
      },
       // 导出功能
      handleExport(type) {

          let params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
            yearPeriods: this.formData.yearPeriods,
          }
          if(type!='Excel') {
              params.type="export";
          }
          const router =this.$router.resolve({
          path: type=='Excel'?'/export/exportCheckGeneralLedger':'/createPDF/checkGeneralLedger',
          query: params
        })

        window.location.href = this.$rootUrl + router.href;
      },
       // 打印功能 
      handlePrint(type) {
          const params = {
            cid: sessionStorage.cid,
            token: sessionStorage.token,
            yearPeriods: this.formData.yearPeriods,
            rotate: type
          }
          const router = this.$router.resolve({
            path: '/createPDF/checkGeneralLedger',
            query: params,
          })

          window.open(this.$rootUrl + router.href, '_blank');
      },
      // 获取打印导出导入按钮权限
      getButtonAuthorize() {
        const _ = this;
        let params={
          permissions:'ac:ledger:print,ac:ledger:export'
        }
         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
            if(res && res.data.code == 1) {
              _.buttonList = res.data.data;
            }
         })
      },
      getData(){
        const _=this;
        let num = 1;
        _.loadings = true;
        _.$http.post('journal/findCheckAccounts',_.formData).then(res=>{
            _.loadings = false;
            if(res && res.data.code == '1'){
              let list = res.data.data;
              for(let i=0;i<list.length;i++){
                list[i].children = list[i].child;
                list[i].id = num++;
                delete list[i].child;

                if(list[i].children.length >0){
                  //期初
                  let initial = list[i].children[0].initialBalance;
                  let initial0 = 0;
                  //借方金额 收入
                  let debitMoney = list[i].children[0].monCountDebitMoney;
                  let debitMoney0 = 0;
                  //借方金额 收入
                  let creditor = list[i].children[0].monCreditorMoney;
                  let creditor0 = 0;
                  //借方金额 收入
                  let remaining = list[i].children[0].monRemainingSum;
                  let remaining0 = 0;
                  for(let j =1;j<list[i].children.length;j++){
                    list[i].children[j].id =Math.random();
                    initial0 += list[i].children[j].initialBalance;
                    debitMoney0 += list[i].children[j].monCountDebitMoney;
                    creditor0 += list[i].children[j].monCreditorMoney;
                    remaining0 += list[i].children[j].monRemainingSum;
                  };

                  for(let j =0;j<list[i].children.length;j++){
                    list[i].children[j].initialBalance = currencys(list[i].children[j].initialBalance);
                    list[i].children[j].monCountDebitMoney = currencys(list[i].children[j].monCountDebitMoney);
                    list[i].children[j].monCreditorMoney = currencys(list[i].children[j].monCreditorMoney);
                    list[i].children[j].monRemainingSum = currencys(list[i].children[j].monRemainingSum);
                  };

                  let all =  Math.abs(initial-initial0)+Math.abs(debitMoney-debitMoney0)+Math.abs(creditor-creditor0)+Math.abs(remaining-remaining0);
                  list[i].children.push({
                      id:Math.random(),
                      initialBalance: currencys(initial-initial0),
                      monCountDebitMoney: currencys(debitMoney-debitMoney0),
                      monCreditorMoney: currencys(creditor-creditor0),
                      monRemainingSum: currencys(remaining-remaining0),
                      subjectCode: "",
                      subjectName: "差额",
                      type:all != 0 ? '不平' : '',
                      myType:all != 0 ? '1' : '0',
                  });
                }
              };
              _.tableData = list;
            }else{
              _.tableData.splice(0);
            }
        }).catch(e=>{
          _.loadings = false;
        });
      },
      forEachList(list){
        for(let i=0;i<list.length;i++){
          list[i].children = list[i].child;
          delete list[i].child;
        }
      },
      getAccountPeriod(){
        const _=this;
        _.$http.post('journal/findCheckAccountPeriod',{}).then(res=>{
          if(res && res.data.code =='1'){
            let list = res.data.data
            _.dictList.option = list;
            let peiods = parseInt(_.$getSessionStorage('yearsPeriod'));
            let bol = false;
            for(let i=0;i<list.length;i++){
              if(list[i].yearPeriods == peiods){
                bol = true;
                _.formData.yearPeriods = peiods;
              }
            };
            if(!bol){
              _.formData.yearPeriods = list[list.length-1].yearPeriods;
            }
            _.getData();
          }
        }).catch(e=>{

        });
      },
      //页码发送变化
      pageIndexChange(page){
      	this.page.pageIndex = page;
      	this.getData();
      },//页码条数发送变化
      pageSizeChange(page){
      	this.page.pageSize = page;
      	this.getData();
      },
    },
    computed: {
  
      getClickCache() {
        return this.$store.state.loadstatus.isClickCache;
      }
    },
    activated() {
      if(this.getClickCache&&this.isFirstActive) {
        this.getAccountPeriod()
      }
      this.isFirstActive = true;
    },
  }
</script>

<style lang="less">
  #cashieraccount {
    .headerStyleColors {
      text-align: center !important;
    }
   /*  .el-table__row{
            &:hover{
              td{
                background-color:#6c6c6c;
              }
            }

         }*/
    td {
      padding: 6px 0;
    }
     .el-table{
        .red{color: red;}
      }
  }
 
</style>



// WEBPACK FOOTER //
// src/pages/cashier/cashierledger.vue